import { getDataFromStorage } from "../../util";
// import AlertContext from "../../context/AlertContext";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import React, { useContext, useEffect, useRef } from "react";
import { ZoomMtg } from "@zoom/meetingsdk";
import constants from "../../constants";
import AlertContext from "../../context/AlertContext";

export default function ZoomStudentView(Props) {
  const { batchName } = useContext(AlertContext);

  let name = `${
    localStorage.getItem("batchname") || batchName
  }$$${getDataFromStorage("name")}(${Props.testname.substring(
    Props.testname.lastIndexOf("_") + 1
  )}${
    JSON.parse(Props.zoomdata).qnno ? "-" + JSON.parse(Props.zoomdata).qnno : ""
  })$$${Object.values(JSON.parse(Props.zoomdata)).toString()}`;

  const axios = useAxiosPrivate();

  let sdkKey = process.env.REACT_APP_ZOOM_MEETING_SDKKEY,
    meetingNumber = process.env.REACT_APP_ZOOM_MEETING_NUMBER,
    passWord = process.env.REACT_APP_ZOOM_MEETING_PASSWORD,
    role = 0,
    userName = name,
    userEmail = "",
    registrantToken = "",
    zakToken = "",
    leaveUrl = process.env.REACT_APP + "/home",
    hasjoined = useRef(false);

  useEffect(() => {
    getSignature();
  }, []);

  const getSignature = (e) => {
    axios
      .post(
        "node/zoom/auth",
        {
          role: role,
          meetingNumber: meetingNumber,
        },
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          startMeeting(response.data.data.signature);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const startMeeting = (signature) => {
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    document.getElementById("zmmtg-root").style.display = "none";
    ZoomMtg.init({
      patchJsMedia: true,
      disablePreview: true,
      isSupportAV: true,
      // leaveUrl: leaveUrl,
      success: (success) => {
        wait(autojoin, 5);
        wait(autoVideo, 5);
        document.getElementById("zmmtg-root").style.display = "none";
        ZoomMtg.join({
          zak: zakToken,
          sdkKey: sdkKey,
          passWord: passWord,
          userName: userName,
          tk: registrantToken,
          userEmail: userEmail,
          signature: signature,
          meetingNumber: meetingNumber,
          success: (success) => {
            wait(autojoin, 5);
            wait(autoVideo, 5);
            HideJoinAudio();
            axios
              .post(
                "node/learner/eventlog",
                {
                  eventtext: "Joined Zoom",
                  userid: getDataFromStorage("learnerid"),
                  qnid: JSON.parse(Props.zoomdata).qnid ?? null,
                  testid: JSON.parse(Props.zoomdata).testid ?? null,
                  tag: "ZOOM_JOIN",
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                console.log("res", res);
              })
              .catch((err) => {
                console.error("error", err);
              });
            ZoomMtg.inMeetingServiceListener("onUserJoin", function (data) {
              ZoomMtg.mute({ userId: data.userId, mute: true });
            });

            ZoomMtg.inMeetingServiceListener("onUserLeave", function (data) {
              ZoomMtg.mute({ userId: data.userId, mute: true });
            });
          },
          error: (error) => {},
        });
      },
      error: (error) => {},
    });
  };

  const HideJoinAudio = () => {
    let joinBtn = document.getElementsByClassName(
      "join-audio-by-voip__join-btn"
    )[0];

    if (joinBtn) {
      wait(JoinAudioAuto, 5);
      wait(OpenJoinAudio, 5);
    } else {
      wait(OpenJoinAudio, 5);
      wait(JoinAudioAuto, 5);
    }

    return;
  };

  const OpenJoinAudio = () => {
    let btn = document.getElementsByClassName("join-audio-container__btn")[0];
    let joinDialog = document.getElementsByClassName("join-dialog")[0];

    if (btn && !joinDialog) {
      btn.click();
    }

    return;
  };

  const JoinAudioAuto = () => {
    let btn = document.getElementsByClassName(
      "join-audio-by-voip__join-btn"
    )[0];
    if (btn) {
      btn.click();
    }

    return;
  };

  let wait = function (callback, seconds) {
    return window.setTimeout(callback, seconds * 1000);
  };

  const autojoin = () => {
    let joinBtn = document.getElementsByClassName("preview-join-button")[0];
    if (hasjoined.current === false) {
      if (joinBtn) {
        joinBtn.click();
        hasjoined.current = true;
      } else {
        wait(autojoin, 5);
      }

      return;
    }
  };

  const autoVideo = () => {
    let videoBtn = document.getElementsByClassName(
      "send-video-container__btn"
    )[0];

    videoBtn && videoBtn.click();
  };

  return (
    <>
      <div className="ZoomApp"></div>
      <div className="dispcomp">{/* <Compa /> */}</div>
    </>
  );
}
